<template>
    <div>
        <el-tabs v-model="tab" tab-position="left" type="border-card" @tab-click="onTabClick">
            <el-tab-pane label="Excel Parser" name="excel-parser">
                <ExcelParser />
            </el-tab-pane>
            <el-tab-pane label="EDI Extractor" name="edi-extractor">
                <EDIExtractor />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import ExcelParser from './pages/ExcelParser/ExcelParser'
import EDIExtractor from './pages/EDIExtractor/EDIExtractor'

export default {
    components: { ExcelParser, EDIExtractor },
    data:() => ({
        tab: 'excel-parser'
    }),
    created(){
        this.checkQuery()
    },
    methods:{
        checkQuery(){
            let tabQuery = this.$route.query.tab
            if(tabQuery === 'excel-parser'){
                this.tab = tabQuery
            }else if(tabQuery === 'edi-extractor'){
                this.tab = tabQuery
            }else if(tabQuery === 'pdf-parser'){
                this.tab = tabQuery
            }else{
                this.tab = 'excel-parser'
            }
        },
        onTabClick(){
            this.$router.replace(`/guide?tab=${this.tab}`).catch(() => {})
        }
    }
}
</script>

<style>
.guide-layout{
    background-color: #fff;
    padding: 20px;
}
li.guide-step{
    margin-bottom: 15px;
    font-size: 15px;
}
li.guide-step > img{
    margin-top: -8px;
    -webkit-box-shadow: 4px 4px 10px -6px #000000; 
    box-shadow: 4px 4px 10px -6px #000000;
}
img.guide{
    margin-top: -8px;
    -webkit-box-shadow: 4px 4px 10px -6px #000000; 
    box-shadow: 4px 4px 10px -6px #000000;
}
</style>